export default "__VITE_ASSET__BPERrqUc__"